export default __webpack_public_path__ + "static/media/doordash-logo.c4d165ca.svg";